export interface IOnSiteGrid {
    moneySiteId?: number;
    basePath: string;
}

import { useRef, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { OrderTypeMenu } from "src/app/components";
import { SiteAnalyzeOnSiteGridContainer } from "src/app/containers";
import { TSelectedRows } from "src/app/containers/AddBoostToOrderModel/AddBoostToOrderModelContainer";
import OnSiteStatsContainer from "src/app/containers/OnSiteStats/OnSiteStatsContainer";
import { OrderOnSiteGrid } from "src/app/types/orders/onSite";
import { TOnSiteOrderType, OnSiteOrderType } from "src/app/types/orders/order";

export interface IOnSiteGrid {
    moneySiteId?: number;
    basePath: string;
}

const OnSiteGrid = (props: IOnSiteGrid) => {
    const { moneySiteId, basePath } = props;
    const [selectedRows, setSelectedRows] = useState<Array<OrderOnSiteGrid>>([]);
    const gridRef = useRef<any>(null);

    const { pathname } = useLocation();
    const orderType = pathname.replaceAll(basePath, "").toUpperCase() as TOnSiteOrderType;

    const [isVisible, setIsVisible] = useState(true);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const handleRowSelection = (rows: Array<any>) => {
        setSelectedRows(rows);
    };

    const convertRows = () => {
        const newRows: Array<TSelectedRows> = [];
        selectedRows.forEach((el) => {
            if (el.url && el.keywords) {
                newRows.push({
                    id: el.id,
                    keywords: el.keywords,
                    url: el.url,
                });
            }
        });
        return newRows;
    };

    return (
        <div className="offsiteGrid">
            <OnSiteStatsContainer
                moneySiteId={moneySiteId}
                selectedRows={selectedRows}
                isVisible={isVisible}
            />
            <OrderTypeMenu
                basePath={basePath}
                siteOrderType={OnSiteOrderType}
                addSeparators={[0]}
                gridRef={gridRef}
                selectedRows={convertRows()}
                onClick={toggleVisibility}
                isVisible={isVisible}
            />
            <SiteAnalyzeOnSiteGridContainer
                moneySiteId={moneySiteId}
                orderType={orderType}
                onRowSelected={handleRowSelection}
                gridRef={gridRef}
                isVisible={isVisible}
            />
            <Routes>
                <Route index element={<Navigate to="lp" />} />
            </Routes>
        </div>
    );
};

export default OnSiteGrid;
